import { useEffect, useState } from "react";
import NewQuote from "../../../../../entities/DashboardPage/AccountingModule/Quotes/CreateQuotes";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";

const QuotesCreate = () => {
    const [customerList, setCustomerList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [attachmentUrl, setAttachmentUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { showAlert } = useAlert()

    useEffect(() => {
        getItem();
        createQuote();
        getCustomerList();
    }, []);

    const createQuote = async (quoteData) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.createQuote(quoteData);
            if (result?.success) {
                setLoading(false);
                LoaderHelper.loaderStatus(false);
                navigate("/dashboard/quotes");
                showAlert("Quote created successfully", "success");
            } else {
                setLoading(false);
                LoaderHelper.loaderStatus(false)
                // showAlert(result.message, "error");
            }
        } catch (apiError) {
            setLoading(false);
            LoaderHelper.loaderStatus(false);
            return;
        }
    }

    const getItem = async (text) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getItemsList(text);

            if (result?.success) {
                setItemList(result?.data?.items);
                LoaderHelper.loaderStatus(false);
            } else {
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {

            LoaderHelper.loaderStatus(false);
        }
    }

    const getCustomerList = async (text, sort, page) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getCustomer(text, sort, page);
            if (result?.success) {
                setCustomerList(result?.data?.customers)
                LoaderHelper.loaderStatus(false);
            } else {
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            LoaderHelper.loaderStatus(false);
        }
    };

    const handleFileUpload = async (file) => {
        if (!file) return;

        LoaderHelper.loaderStatus(true);
        try {
            const formData = new FormData();
            formData.append('file', file);

            const result = await AuthService.uploadFile(formData);
            if (result?.success) {
                setAttachmentUrl(result.data.url);
                LoaderHelper.loaderStatus(false);
            } else {
                LoaderHelper.loaderStatus(false);
            }
        } catch (error) {
            console.error('File upload failed:', error);
            LoaderHelper.loaderStatus(false);
        }
    };

    return (
        <NewQuote
            customerList={customerList}
            itemList={itemList}
            handleItem={getItem}
            handleFileUpload={handleFileUpload}
            attachmentUrl={attachmentUrl}
            createQuote={createQuote}
            loading={loading}
        />
    );
};

export default QuotesCreate;